import React, { Component } from "react";
import { connect } from "react-redux";
// import Search from "./Search";
import Section from "./Section";
import { checkSelfServicePermission } from "../Routes/Pages";

class ClientForms extends Component {
  state = {
    Sections: [
      {
        Colour: "viking",
        Items: [
          {
            Icon: "omni-stamped-document",
            Title: this.props._.ClientHub.ReportBreach,
            Colour: "viking",
            RedirectPath: "/client-forms/report-breach",
          },
          ...(checkSelfServicePermission(this.props.User)
            ? [
                {
                  Icon: "omni-stamped-document",
                  Title: this.props._.ClientHub.ClientOrder,
                  Colour: "ocean-green",
                  RedirectPath: "/client-forms/client-order",
                },
                {
                  Icon: "omni-stamped-document",
                  Title: this.props._.ClientHub.ContactClientCare,
                  Colour: "buttercup",
                  RedirectPath: "/client-forms/contact-client-care",
                },
              ]
            : []),
          ,
        ],
      },
    ],
  };

  render() {
    const _ = this.props._;

    return (
      <>
        <h2>{_.ClientHub.ClientFormsTitle}</h2>
        <div className="help-guide flex-grow-1">
          <div className="container-fluid h-100 d-flex flex-column">
            {/* <Search /> */}
            <div className=" flex-grow-1 flex-column">
              {this.state.Sections.map((hs, key) => (
                <Section {...hs} key={key} />
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
}
export const mapStatetoProps = ({ _, User }) => ({ _, User });
export default connect(mapStatetoProps)(ClientForms);
